<template>
  <div class="page-container">
    <section class="mt-4 mb-10">
      <h1 v-if="me" class="font-size--24">
        {{ me.name }} 사장님!<br />미래의 매출을 미리 받아보세요!
      </h1>
      <v-footer fixed>
        <v-layout :class="{ 'px-3': !$vuetify.breakpoint.mobile }">
          <BasicButton class="button next-button" depressed height="48" @click="pullRevenue">
            신청하기
          </BasicButton>
        </v-layout>
      </v-footer>
    </section>
    <section>
      <ul class="font-size--14 color--nice-grey outer">
        <li>미래매출 당겨받기는 P2P 방식으로 온라인 모집하여 지급합니다.</li>
        <li>모집 기간은 5일이며, 신청하신 금액 중 일부만 모집-지급될 수 있습니다.</li>
      </ul>
    </section>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { defaultApi } from '@/plugins/api/defaultApi'
import { redirectSignupManage } from '@/util/signupManage'
export default {
  computed: {
    ...mapState('auth', ['me']),
  },
  async created() {
    _meta({
      titles: ['당겨받기설명'],
    })
    if (await redirectSignupManage()) {
      return
    }
  },
  watch: {
    me: {
      deep: true,
      immediate: true,
      async handler() {
        
      },
    },
  },
  methods: {
    ...mapActions('auth', ['getMe']),
    ...mapActions('loansRequest', {
      storeAddRequest: 'addRequest',
      storeGetRequests: 'getRequests',
    }),
    async pullRevenue() {
      await this.$router.push('/loan/pull-revenue')
    },
  },
}
</script>
<style lang="scss" scoped>
#section__success {
  .v-card {
    background-color: #f4faff;
  }
}
</style>
